@if (error) {
  <div class="banner">
    <!-- <div class="banner"> -->
    <div class="text-start">
      <div class="fs-15">New version available.</div>
      <div class="opacity-70p fs-13">Your application needs to be reloaded to continue</div>
    </div>
    <button (click)="reloadWithForcedHardReload()">Click here to reload</button>
  </div>
}
